/**
 * Permission slugs aligned with the admin API gateway (`HasPermission` decorators).
 * Use these with `hasPermission` pipe / `PermissionService` instead of hard-coded strings in templates.
 */
export const ADMIN_PERMISSION_SLUGS = {
  /** PD List (`pd-list.json` seed) */
  PD_LIST: 'pd_list',
  PD_ADD: 'add_pd',
  PD_UPDATE: 'update_pd',
  PD_DELETE: 'delete_pd',
  PD_VIEW: 'view_pd',
  PD_EXPORT: 'export_pd',

  /** Audit Trail — PD sessions and portal sign-ins on one timeline. */
  AUDIT_TRAIL_LIST: 'audit_trail_list',

  /** PD Links (`pd-link.json` seed) */
  PD_LINKS: 'pd_links',
  PD_LINK_ADD: 'add_pd_link',
  PD_LINK_UPDATE: 'update_pd_link',
  PD_LINK_DELETE: 'delete_pd_link',
  PD_LINK_VIEW: 'view_pd_link',
  PD_LINK_SEND: 'send_pd_link',
  PD_LINK_CLONE: 'clone_pd_link',
  PD_LINK_EXPORT: 'export_pd_link',

  /** User (`user.json` seed) */
  USER_LIST: 'list_users',
  USER_ADD: 'add_user',
  USER_UPDATE: 'update_user',
  USER_DELETE: 'delete_user',
  USER_TOGGLE_STATUS: 'toggle_user_status',
  USER_IMPORT: 'import_user',
  USER_RESTORE: 'restore_user',
  USER_VIEW: 'view_user',
  USER_EXPORT: 'export_user',
  USER_RESEND_LINK: 'resend_user_link',
  MANAGE_AGENT: 'manage_agent',
  /** Role (`role.json` seed) */
  ROLE_LIST: 'list_roles',
  ROLE_ADD: 'add_role',
  ROLE_UPDATE: 'update_role',
  ROLE_DELETE: 'delete_role',
  ROLE_RESTORE: 'restore_role',
  ROLE_TOGGLE_STATUS: 'toggle_role_status',
  ROLE_ATTACH_PERMISSION: 'attach_permission_to_role',
  PERMISSION_LIST: 'list_permissions',
  /** Rule Packs (`rule-packs.json` seed) — compliance thresholds + AI pipeline config */
  RULE_PACK_LIST: 'rule_pack_list',
  RULE_PACK_EDIT: 'edit_rule_pack',

  /** Billing */
  BILLING: 'view_billing',

  /** Subscriptions (`subscription.json` seed) — profile dropdown + /subscriptions */
  SUBSCRIPTION_LIST: 'list_subscriptions',

  /** Organization Details (`/system-preferences` → Organization Details) */
  ORGANIZATION_DETAILS_LIST: 'list_organization_details',
  ORGANIZATION_DETAILS_UPDATE: 'update_organization_details',

  /** SMTP Settings (`/system-preferences` → Manage SMTP Settings) */
  SMTP_SETTINGS_LIST: 'list_smtp_configs',
  SMTP_SETTINGS_UPDATE: 'update_smtp_config',
} as const;
